<template>
    <div class="smooth-list">
        <ul class="list">
            <li class="list-item" v-for="func in functions" @click="insert(func.html)">
                <div>
                    <div class="action pull-left margin-right-15">
                        <button class="btn btn-sm btn-outline dark">
                            <i class="glyphicon glyphicon-plus"></i>
                        </button>
                    </div>
                    <div class="list-item-info">
                        <div class="item-title" v-text="func.name"></div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "function-list",

        data() {
            return {
                functions: {
                    sum: {
                        html: this.sumHTML(),
                        name: 'SUM()'
                    },
                    avg: {
                        html: this.avgHTML(),
                        name: 'AVG()'
                    },
                    count: {
                        html: this.countHTML(),
                        name: 'COUNT()'
                    },
                    whereFirst: {
                        html: this.whereFirstHTML(),
                        name: 'WHERE-FIRST()'
                    },
                    whereLast: {
                        html: this.whereLastHTML(),
                        name: 'WHERE-LAST()'
                    },
                    where: {
                        html: this.whereHTML(),
                        name: 'WHERE()'
                    },
                    whereBetween: {
                        html: this.whereBetweenHTML(),
                        name: 'WHERE-BETWEEN()'
                    },
                    whereIn: {
                        html: this.whereInHTML(),
                        name: 'WHERE-IN()'
                    },
                    date: {
                        html: this.dateHTML(),
                        name: 'DATE()'
                    },
                    if: {
                        html: this.ifHTML(),
                        name: 'IF()'
                    },
                    ifElse: {
                        html: this.ifElseHTML(),
                        name: 'IF/ELSE()'
                    },
                    renderHTML: {
                        html: this.renderHTMLHTML(),
                        name: 'RENDER-HTML()'
                    },
                }
            }
        },

        methods: {
            insert(func) {
                this.$emit('insert', {
                    func: func
                })
            },

            sumHTML() {
                return "<span class='blade-function-tag blade-collection-function mceNonEditable'>@sum(<span class='mceEditable'>&nbsp;<span class='__cursor'>&nbsp;</span></span>)</span>"
            },

            avgHTML() {
                return "<span class='blade-function-tag blade-collection-function mceNonEditable'>@avg(<span class='mceEditable'>&nbsp;<span class='__cursor'>&nbsp;</span></span>)</span>"
            },

            countHTML() {
                return "<span class='blade-function-tag blade-collection-function mceNonEditable'>@count(<span class='mceEditable'>&nbsp;<span class='__cursor'>&nbsp;</span></span>)</span>"
            },

            whereFirstHTML() {
                return `
                    <span class='blade-function-tag blade-collection-function mceNonEditable'>
                        @whereFirst(
                            <span class='mceEditable'>&nbsp;<span class='__cursor'>&nbsp;</span></span>,
                            <span class='mceEditable'>'=='</span>,
                            <span class='mceEditable'>'value'</span>,
                            <span class='mceEditable'>&nbsp;<span class='__cursor'>&nbsp;</span></span>
                        )
                    </span>
                `
            },

            whereLastHTML() {
                return `
                    <span class='blade-function-tag blade-collection-function mceNonEditable'>
                        @whereLast(
                            <span class='mceEditable'>&nbsp;<span class='__cursor'>&nbsp;</span></span>,
                            <span class='mceEditable'>'=='</span>,
                            <span class='mceEditable'>'value'</span>,
                            <span class='mceEditable'>&nbsp;<span class='__cursor'>&nbsp;</span></span>
                        )
                    </span>
                `
            },

            whereHTML() {
                return `
                    <span class='blade-function-tag blade-collection-function mceNonEditable'>
                        @where(
                            <span class='mceEditable'>&nbsp;<span class='__cursor'>&nbsp;</span></span>,
                            <span class='mceEditable'>'=='</span>,
                            <span class='mceEditable'>'value'</span>,
                            <span class='mceEditable'>'SUM'</span>,
                            <span class='mceEditable'>&nbsp;<span class='__cursor'>&nbsp;</span></span>
                        )
                    </span>
                `
            },

            whereBetweenHTML() {
                return `
                    <span class='blade-function-tag blade-collection-function mceNonEditable'>
                        @whereBetween(
                            <span class='mceEditable'>&nbsp;<span class='__cursor'>&nbsp;</span></span>,
                            <span class='mceEditable'>'value1' AND 'value2'</span>,
                            <span class='mceEditable'>'SUM'</span>,
                            <span class='mceEditable'>&nbsp;<span class='__cursor'>&nbsp;</span></span>
                        )
                    </span>
                `
            },

            whereInHTML() {
                return `
                    <span class='blade-function-tag blade-collection-function mceNonEditable'>
                        @whereIn(
                            <span class='mceEditable'>&nbsp;<span class='__cursor'>&nbsp;</span></span>,
                            <span class='mceEditable'>'value1' AND 'value2' AND 'value3'</span>,
                            <span class='mceEditable'>'SUM'</span>,
                            <span class='mceEditable'>&nbsp;<span class='__cursor'>&nbsp;</span></span>
                        )
                    </span>
                `
            },

            ifHTML() {
                return `
                    <div class='blade-statement blade-if-statement mceNonEditable'>
                        <p class="blade-function-tag blade-if-statement-tag mceEditable">@if(<span class='__cursor'>&nbsp;</span>)</p>
                        <div class="mceEditable">
                            <p></p>
                        </div>
                        <p class="blade-function-tag">@endif</p>
                    </div>
                `
            },

            ifElseHTML() {
                return `
                    <div class='blade-statement blade-if-statement mceNonEditable'>
                        <p class="blade-function-tag blade-if-statement-tag mceEditable">@if(<span class='__cursor'>&nbsp;</span>)</p>
                        <div class="mceEditable">
                            <p></p>
                        </div>
                        <p class="blade-function-tag">@else</p>
                        <div class="mceEditable">
                            <p></p>
                        </div>
                        <p class="blade-if-statement-tag">@endif</p>
                    </div>
                `
            },

            renderHTMLHTML() {
                return "<span class='blade-function-tag blade-render-table-function mceNonEditable'>@renderHTML(<span class='mceEditable'>&nbsp;<span class='__cursor'>&nbsp;</span></span>)</span>"
            },

            dateHTML() {
                return "<span class='blade-function-tag blade-date-function mceNonEditable'>@date(<span class='mceEditable'>&nbsp;<span class='__cursor'>&nbsp;</span></span>, <span class='mceEditable'>&nbsp;<span class='__cursor'>'d.m.Y'</span></span>)</span>"
            }
        },


    }
</script>
